import { render, staticRenderFns } from "./CashbackSideSheet.vue?vue&type=template&id=06c18a74&scoped=true"
import script from "./CashbackSideSheet.vue?vue&type=script&setup=true&lang=ts"
export * from "./CashbackSideSheet.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CashbackSideSheet.vue?vue&type=style&index=0&id=06c18a74&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06c18a74",
  null
  
)

export default component.exports